import { InvoiceDto } from '@api';

export const INVOICES: InvoiceDto[] = [];
